import { IconButton, InputAdornment, TextField, useTheme } from '@mui/material'

import LockTwoTone from '@mui/icons-material/LockTwoTone'
import VisibilityOffTwoTone from '@mui/icons-material/VisibilityOffTwoTone'
import VisibilityTwoTone from '@mui/icons-material/VisibilityTwoTone'
import { useState } from 'react'

const ToggleField = ({ label, toggleAriaLabel, slotProps = {}, ...rest }) => {
  const [visible, setVisible] = useState(false)
  const theme = useTheme()

  const ariaLabel =
    toggleAriaLabel ||
    `toggle ${label ? label.toLowerCase() : 'field'} visibility`

  const { input: inputSlotProps, ...restSlotProps } = slotProps

  return (
    <TextField
      {...rest}
      label={label}
      type={visible ? 'text' : 'password'}
      slotProps={{
        ...restSlotProps,
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <LockTwoTone sx={{ color: theme.palette.text.secondary }} />
            </InputAdornment>
          ),
          ...inputSlotProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={ariaLabel}
                onClick={() => setVisible((prev) => !prev)}
                edge="end"
              >
                {visible ? <VisibilityOffTwoTone /> : <VisibilityTwoTone />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  )
}

export default ToggleField
